
































































































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import Alert from "@/components/BaseAlert/BaseAlert.vue";
import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";
import StickyListHeader from "@/components/StickyListHeader/StickyListHeader.vue";
import DataTable from "@/components/DataTable/DataTable.vue";
import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";

import RequestState from "@/utils/mixins/RequestState";

import { LessonsFormData } from "./Lessons.vue";
import { ILesson } from "@/models/interfaces/lessons";
import { ILevel, ISchool } from "@/models/interfaces/schools";
import { IVuexState } from "@/models/interfaces/store";
import { IClass } from "@/models/interfaces/classes";
import { Action, State } from "vuex-class";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

enum LessonState {
  Current,
  Archived,
  Unassigned,
  Selected
}

@Component({
  components: {
    AppHeader,
    AppHeaderBackWithTitle,
    AppContent,
    BaseButton,
    Alert,
    Spinner,
    StickyListHeader,
    DataTable,
    BaseDropdown
  }
})
export default class LessonsStep2View extends Mixins(RequestState) {
  @Prop({ required: true })
  private form!: LessonsFormData;

  @Prop({ required: true })
  private schools!: IVuexState<ISchool[]>;

  @Prop({ required: true })
  private classes!: IVuexState<IClass[]>;

  @Prop({ required: true })
  private lessons!: IVuexState<ILesson[]>;

  @Action("schools/fetchLevels")
  private fetchLevels!: (schoolsIds: string[]) => Promise<ILevel[]>;

  @State("levels", { namespace: "schools" })
  private levels!: IVuexState<ILevel[]>;

  private filterLevelId = "";

  private get disabled() {
    return !this.form.lessonId;
  }

  private get levelsOptions() {
    return (
      this.levels.data?.map(level => ({
        label: level.title,
        value: level.levelId
      })) || []
    );
  }

  private get tableColumns() {
    return [
      {
        value: "level",
        label: this.$t("tables.lessons.level")
      },
      {
        value: "topic",
        label: this.$t("tables.lessons.topic")
      },
      {
        value: "title",
        label: this.$t("tables.lessons.lesson")
      },
      {
        value: "description",
        label: this.$t("tables.lessons.summary")
      },
      {
        label: this.$t("tables.lessons.content"),
        name: "content",
        value: "content",
        custom: true
      },
      {
        label: this.$t("tables.lessons.status"),
        name: "status",
        value: "status",
        custom: true
      }
    ];
  }

  private getStateForLesson(lesson: ILesson) {
    if (Number(this.form.lessonId) === lesson.lessonId) {
      return {
        label: this.$t("views.lessons.statuses.selected"),
        state: LessonState.Selected
      };
    }

    if (this.form.classesIds.length === 1) {
      const { archivedClasses, assignedClasses } = lesson;

      if (archivedClasses.includes(this.form.classesIds[0])) {
        return {
          label: this.$t("views.lessons.statuses.archived"),
          state: LessonState.Archived
        };
      }

      if (assignedClasses.includes(this.form.classesIds[0])) {
        return {
          label: this.$t("views.lessons.statuses.current"),
          state: LessonState.Current
        };
      }

      return {
        state: LessonState.Unassigned,
        label: this.$t("views.lessons.statuses.unassigned")
      };
    } else {
      return {
        state: LessonState.Unassigned,
        label: this.$t("views.lessons.statuses.unassigned")
      };
    }
  }

  private handleLessonClick(lesson: ILesson) {
    this.$emit("on-input-change", "lessonId", lesson.lessonId);
  }

  private handleSubmit() {
    if (!this.disabled) {
      amplitude
        .getInstance()
        .logEvent(
          `${eventCodeByName(EventsNames.UserClicksNextOnLessons)} ${
            EventsNames.UserClicksNextOnLessons
          }`
        );
      this.$emit("on-next");
    }
  }

  private onActivityBtnClick(row: ILesson) {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksViewActivityThumbnails)} ${
          EventsNames.UserClicksViewActivityThumbnails
        }`
      );

    this.$emit("on-activity-click", row.lessonId);
  }

  private onZipClick() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksZip)} ${
          EventsNames.UserClicksZip
        }`
      );
  }

  private onPdfClick() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksViewPdf)} ${
          EventsNames.UserClicksViewPdf
        }`
      );
  }

  public mounted() {
    this.fetchLevels(this.form.schoolsIds);
  }

  @Watch("filterLevelId")
  private filterByLevel(levelId: string) {
    this.$emit("on-filter-lessons", levelId);
  }
}
